export enum CommitteeType {
    Institution = 1,
    County,
    Ministry,
    Regional,

    /**
     * This refers to extra Committee Positions that are added 
     * to an InstitutionCommittee but administered by the County.
     */
    InstitutionExtra = 99,
}